// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxu cz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJPdXRsaW5lIiB2aWV3 Qm94PSIwIDAgMjQgMjQiIHN0cm9rZT0iIzg4ODg4OCIgZmlsbD0iIzg4ODg4OCIg d2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiPjxwYXRoIGQ9Ik0xNiw4YTEsMSwwLDAs MC0xLjQxNCwwTDEyLDEwLjU4Niw5LjQxNCw4QTEsMSwwLDAsMCw4LDkuNDE0TDEw LjU4NiwxMiw4LDE0LjU4NkExLDEsMCwwLDAsOS40MTQsMTZMMTIsMTMuNDE0LDE0 LjU4NiwxNkExLDEsMCwwLDAsMTYsMTQuNTg2TDEzLjQxNCwxMiwxNiw5LjQxNEEx LDEsMCwwLDAsMTYsOFoiLz48cGF0aCBkPSJNMTIsMEExMiwxMiwwLDEsMCwyNCwx MiwxMi4wMTMsMTIuMDEzLDAsMCwwLDEyLDBabTAsMjJBMTAsMTAsMCwxLDEsMjIs MTIsMTAuMDExLDEwLjAxMSwwLDAsMSwxMiwyMloiLz48L3N2Zz4K", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.tab-container .tab-bar {
  display: flex;
  align-self: stretch;
  padding: 0;
}
.tab-container .tab-bar ul {
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  overflow-x: scroll;
  align-self: stretch;
  padding: 0;
  margin: 0;
  gap: 2px;
  box-sizing: border-box;
  position: relative;
}
.tab-container .tab-bar ul::-webkit-scrollbar {
  width: 100%;
  height: 4px;
}
.tab-container .tab-bar ul::-webkit-scrollbar-track {
  background: #DDE3E7;
}
.tab-container .tab-bar ul::-webkit-scrollbar-thumb {
  background: rgba(8, 75, 131, 0.5);
  border-radius: 8px;
  cursor: pointer;
}
.tab-container .tab-bar ul::-webkit-scrollbar-thumb:hover {
  background: #084B83;
}
.tab-container .tab-bar li {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  white-space: nowrap;
  padding: 8px 18px;
  cursor: pointer;
  color: #303443;
  font-size: 14px !important;
  font-weight: 400;
  border-radius: 8px 8px 0 0;
  border: 1px solid #DCE7F2;
  border-bottom: none;
  background-color: white;
  z-index: 5;
}
.tab-container .tab-bar li.active {
  background-color: #F8FCFF;
  color: #084B83;
  font-weight: 700;
  z-index: 15;
}
.tab-container .tab-content {
  display: flex;
  height: 100%;
  overflow-y: scroll;
  flex-direction: column;
  padding: 16px;
  border: 1px solid #DCE7F2;
  background-color: #F8FCFF;
  border-top: none;
}
.tab-container .tab-content .tab {
  display: none;
}
.tab-container .tab-content .tab.active {
  display: block;
}
.icure-form {
  gap: 16px 6px;
}
.icure-form .group.bordered {
  padding: 12px;
  background-color: white;
  border: 1px solid #9ABFE0FF;
}
.icure-form .group.bordered h3 {
  padding: 0;
  margin: 0 0 16px;
}
.icure-form .group.bordered .icure-form {
  padding-left: 12px;
}
.icure-text-field,
.icure-button-group {
  width: 100%;
}
.icure-text-field .icure-label,
.icure-button-group .icure-label {
  color: #1D2235;
  font-size: 14px !important;
  font-weight: 400;
  min-height: 0;
  max-width: 100%;
  margin-bottom: 6px;
}
.icure-text-field .icure-label > span,
.icure-button-group .icure-label > span {
  display: block;
  word-wrap: break-word;
  overflow: auto;
  font-weight: 400;
}
.icure-text-field .error,
.icure-button-group .error {
  margin-top: 0;
}
.icure-text-field > .icure-input,
.icure-button-group > .icure-input {
  flex: 1 1 auto;
  width: auto;
}
.icure-text-field .icure-input,
.icure-button-group .icure-input,
.icure-text-field .input-container,
.icure-button-group .input-container {
  cursor: pointer;
  border-radius: 6px;
  padding: 8px;
  width: 100%;
  border-width: 1px;
  border-style: solid;
  outline: 0;
  font: inherit;
  font-size: 13px !important;
  line-height: 1.4em !important;
  display: flex;
  align-items: center;
  vertical-align: middle;
  position: relative;
  -webkit-appearance: none;
  background-color: #ffffff;
  border-color: #DDE3E7;
  color: #1D2235;
  box-sizing: border-box;
}
.icure-text-field .icure-input__validationError,
.icure-button-group .icure-input__validationError,
.icure-text-field .input-container__validationError,
.icure-button-group .input-container__validationError {
  border-color: red;
}
.icure-text-field .icure-input__withMetadata,
.icure-button-group .icure-input__withMetadata,
.icure-text-field .input-container__withMetadata,
.icure-button-group .input-container__withMetadata {
  border-radius: 6px 0 0 6px;
}
.icure-text-field .icure-input:focus,
.icure-button-group .icure-input:focus,
.icure-text-field .input-container:focus,
.icure-button-group .input-container:focus,
.icure-text-field .icure-input:focus-within,
.icure-button-group .icure-input:focus-within,
.icure-text-field .input-container:focus-within,
.icure-button-group .input-container:focus-within {
  box-shadow: 0px 0px 0px 2px rgba(61, 135, 197, 0.2) !important;
  border-color: #084B83;
}
.icure-text-field .icure-input:hover,
.icure-button-group .icure-input:hover,
.icure-text-field .input-container:hover,
.icure-button-group .input-container:hover {
  border-color: #084B83;
  box-shadow: none;
}
.icure-text-field .icure-input:hover:focus,
.icure-button-group .icure-input:hover:focus,
.icure-text-field .input-container:hover:focus,
.icure-button-group .input-container:hover:focus,
.icure-text-field .icure-input:hover:focus-within,
.icure-button-group .icure-input:hover:focus-within,
.icure-text-field .input-container:hover:focus-within,
.icure-button-group .input-container:hover:focus-within {
  box-shadow: 0px 0px 0px 2px rgba(61, 135, 197, 0.2) !important;
  border-color: #084B83;
}
.icure-text-field .icure-input .ProseMirror,
.icure-button-group .icure-input .ProseMirror,
.icure-text-field .input-container .ProseMirror,
.icure-button-group .input-container .ProseMirror {
  padding: 0;
  font-size: 13px !important;
  line-height: 1.4em !important;
  color: #1D2235;
}
.icure-text-field .icure-input .ProseMirror .date,
.icure-button-group .icure-input .ProseMirror .date,
.icure-text-field .input-container .ProseMirror .date,
.icure-button-group .input-container .ProseMirror .date {
  padding: 1px;
}
.icure-text-field .icure-input .ProseMirror .time,
.icure-button-group .icure-input .ProseMirror .time,
.icure-text-field .input-container .ProseMirror .time,
.icure-button-group .input-container .ProseMirror .time {
  padding: 1px;
}
.icure-text-field .icure-input .ProseMirror:focus .focused,
.icure-button-group .icure-input .ProseMirror:focus .focused,
.icure-text-field .input-container .ProseMirror:focus .focused,
.icure-button-group .input-container .ProseMirror:focus .focused,
.icure-text-field .icure-input .ProseMirror:hover,
.icure-button-group .icure-input .ProseMirror:hover,
.icure-text-field .input-container .ProseMirror:hover,
.icure-button-group .input-container .ProseMirror:hover {
  border-color: #084B83;
}
.icure-text-field .icure-input > svg,
.icure-button-group .icure-input > svg,
.icure-text-field .input-container > svg,
.icure-button-group .input-container > svg {
  opacity: 0.5;
}
.icure-text-field .icure-input > svg path,
.icure-button-group .icure-input > svg path,
.icure-text-field .input-container > svg path,
.icure-button-group .input-container > svg path {
  fill: #656565;
}
.icure-text-field .icure-input .extra,
.icure-button-group .icure-input .extra,
.icure-text-field .input-container .extra,
.icure-button-group .input-container .extra {
  height: 20px;
}
.icure-text-field .icure-input .extra > .info,
.icure-button-group .icure-input .extra > .info,
.icure-text-field .input-container .extra > .info,
.icure-button-group .input-container .extra > .info {
  color: #656565;
  opacity: 0.5;
}
.icure-text-field .icure-input .extra .buttons-container .btn svg path,
.icure-button-group .icure-input .extra .buttons-container .btn svg path,
.icure-text-field .input-container .extra .buttons-container .btn svg path,
.icure-button-group .input-container .extra .buttons-container .btn svg path {
  fill: #656565;
  opacity: 0.5;
}
.icure-text-field .icure-input .extra .buttons-container .btn svg path:hover,
.icure-button-group .icure-input .extra .buttons-container .btn svg path:hover,
.icure-text-field .input-container .extra .buttons-container .btn svg path:hover,
.icure-button-group .input-container .extra .buttons-container .btn svg path:hover {
  fill: #656565;
  opacity: 1;
}
.icure-text-field .icure-input .extra > .options > .selected,
.icure-button-group .icure-input .extra > .options > .selected,
.icure-text-field .input-container .extra > .options > .selected,
.icure-button-group .input-container .extra > .options > .selected {
  color: white;
  background-color: #084B83;
}
.icure-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  padding: 0 16px;
  background-color: #084B83;
  color: white;
  border-radius: 6px;
  cursor: pointer;
}
.icure-button:hover {
  background-color: #3D87C5;
}
.menu-container .item:hover {
  background: #DCE7F2;
  color: #274768;
  cursor: pointer;
}
.menu-container .item.existing {
  background-color: #BFE8EA;
}
.menu-container .item.selected {
  color: white;
  background-color: #084B83;
}
input[type='radio'] {
  margin-top: -1px;
  vertical-align: middle;
}
.icure-checkbox:hover {
  border-color: #DCE7F2;
}
.icure-checkbox:checked {
  accent-color: #084B83;
}
.icure-button-group {
  gap: 0px;
}
.icure-button-group > div {
  display: grid;
  gap: 4px;
}
.icure-button-group > div > div {
  display: flex;
  gap: 6px;
}
.icure-button-group > div > div > .icure-button-group-label {
  z-index: 1;
  line-height: 1.4em !important;
  cursor: text;
  font-size: 14px !important;
  top: add-three(1.4em, 1px, 0) !important;
  left: add-two(8px, 1px);
  transition: transform 0.2s ease-out, color 0.2s ease-out !important;
  color: #1D2235;
  display: flex;
  align-items: center;
  max-width: 100%;
  min-width: 0;
  height: auto;
  min-height: 0;
}
.icure-button-group > div > div > .icure-button-group-label > span {
  display: block;
  white-space: wrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-right: 8px;
}
.icure-button-group > .icure-input {
  flex: 1 1 auto;
  width: auto;
}
.icure-input #editor {
  color: #1D2235;
}
.icure-input #editor.tokens-list .ProseMirror li,
.icure-input #editor.styled-tokens-list .ProseMirror li {
  background-color: #DCE7F2;
}
.icure-input #editor.tokens-list .ProseMirror li span:after,
.icure-input #editor.styled-tokens-list .ProseMirror li span:after {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 16px;
}
.icure-input #editor.items-list .ProseMirror li {
  border-bottom: 1px dotted #8DA6BF;
}
.icure-input .select-arrow {
  opacity: 1;
}
.icure-input .select-arrow svg {
  width: 15px;
  height: 15px;
}
.icure-input .select-arrow svg path {
  fill: #9CA8B2;
}
.icure-input .options {
  padding: 2px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  border-radius: 6px;
  background: white;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 0px rgba(0, 0, 0, 0.05);
}
.icure-input .options .option {
  height: auto;
  min-height: unset;
  display: flex;
  padding: 8px;
  align-items: center;
  align-self: stretch;
  border-radius: 4px;
  background: white;
  color: #1D2235;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}
.icure-input .options .option:hover {
  background: #DCE7F2;
  color: #084B83;
}
.icure-input:hover .select-arrow svg path,
.icure-input:focus .select-arrow svg path {
  fill: #084B83;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
